import { render, staticRenderFns } from "./TestActivitiAuditForm.vue?vue&type=template&id=a75cc36e"
import script from "./TestActivitiAuditForm.vue?vue&type=script&lang=js"
export * from "./TestActivitiAuditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a75cc36e')) {
      api.createRecord('a75cc36e', component.options)
    } else {
      api.reload('a75cc36e', component.options)
    }
    module.hot.accept("./TestActivitiAuditForm.vue?vue&type=template&id=a75cc36e", function () {
      api.rerender('a75cc36e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/activiti/TestActivitiAuditForm.vue"
export default component.exports